import { useCallback } from "react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { useSimulatePurchase } from "@/hooks/api/mutate/useSimulatePurchase";
import { envConfig } from "@/lib/config";

type Props = {
  checkoutId: string | null;
};

export default function DevSimulatePurchaseButton({ checkoutId }: Props) {
  const { toast } = useToast();
  const simulatePurchase = useSimulatePurchase();

  const handleClick = useCallback(() => {
    if (!checkoutId) return;
    simulatePurchase.mutate(checkoutId, {
      onError: (err) => {
        toast({
          title: "Simulare eșuată",
          description:
            err instanceof Error ? err.message : "Eroare necunoscută",
          variant: "destructive",
        });
      },
    });
  }, [checkoutId, simulatePurchase, toast]);

  if (!envConfig.IS_DEV || !checkoutId) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <Button
        variant="outline"
        size="sm"
        onClick={handleClick}
        disabled={simulatePurchase.isPending}
        className="border-dashed"
      >
        {simulatePurchase.isPending
          ? "Se simulează..."
          : "DEV: Simulează plata"}
      </Button>
    </div>
  );
}
